import { PlusOutlined, EnvironmentOutlined } from "@ant-design/icons"
import { Alert, Button, Empty, Input, Pagination, Space, Spin, Switch, Tag, Typography } from "antd"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { IdentityEditor } from "../../components/physical/IdentityEditor"
import { usePhysicalResource } from "../../components/physical/usePhysicalResource"
import { physicalApi, physicalError } from "../../utils/physicalApi"
import "./physical.css"
import { useSyncronizationContext } from "../../providers/syncronizationProvider"
export function PhysicalSitesPage() {
  const { currentEnterprise } = useSyncronizationContext()
  const [search, setSearch] = useState("")
  const [query, setQuery] = useState("")
  const [page, setPage] = useState(1)
  const [archived, setArchived] = useState(false)
  const [creating, setCreating] = useState(false)
  useEffect(() => {
    const timer = setTimeout(() => {
      setQuery(search)
      setPage(1)
    }, 250)
    return () => clearTimeout(timer)
  }, [search])
  const resource = usePhysicalResource(`sites/${query}/${archived}/${page}`, (signal) =>
    physicalApi.list(
      "site",
      {
        enterpriseUuid: currentEnterprise?.UUID,
        q: query,
        archived,
        limit: 24,
        offset: (page - 1) * 24,
      },
      signal,
    ),
  )
  return (
    <main className="physical-workspace">
      <div className="physical-heading">
        <div>
          <Typography.Title level={2}>
            <EnvironmentOutlined aria-hidden="true" /> Gestionnaire de Sites
          </Typography.Title>
          <Typography.Text type="secondary">
            Un dossier par lieu, pour retrouver son inventaire, ses notes et ses inspections
            successives.
          </Typography.Text>
        </div>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => setCreating(true)}>
          Nouveau site
        </Button>
      </div>
      <Link to="/site-operations">Planning et suivi de tous les sites</Link>
      <Space wrap>
        <Input.Search
          aria-label="Rechercher un site"
          placeholder="Nom ou code du site"
          value={search}
          maxLength={200}
          onChange={(e) => setSearch(e.target.value)}
          allowClear
          style={{ maxWidth: 340 }}
        />
        <label>
          <Switch
            checked={archived}
            onChange={(v) => {
              setArchived(v)
              setPage(1)
            }}
          />{" "}
          Afficher les sites archivés
        </label>
      </Space>
      {resource.error && (
        <Alert
          type="error"
          message={physicalError(resource.error)}
          action={<Button onClick={resource.reload}>Réessayer</Button>}
        />
      )}
      {resource.loading && <Spin />}
      {resource.data && (
        <>
          {resource.data.items.length === 0 ? (
            <Empty
              description={
                query
                  ? "Aucun site correspondant"
                  : archived
                    ? "Aucun site archivé"
                    : "Créez un site, puis rattachez ses inspections existantes."
              }
            />
          ) : (
            <div className="physical-grid">
              {resource.data.items.map((site) => (
                <Link className="physical-tile" key={site.uuid} to={`/physical-sites/${site.uuid}`}>
                  <Space>
                    <EnvironmentOutlined aria-hidden="true" />
                    {site.code && <Tag>{site.code}</Tag>}
                    {site.archived && <Tag>Archivé</Tag>}
                  </Space>
                  <h3>{site.name}</h3>
                  <p>{site.address || "Adresse non renseignée"}</p>
                  <span>Ouvrir le dossier →</span>
                </Link>
              ))}
            </div>
          )}
          <Pagination
            current={page}
            pageSize={24}
            total={resource.data.total}
            showSizeChanger={false}
            onChange={setPage}
            showTotal={(n) => `${n} sites`}
          />
        </>
      )}
      {creating && (
        <IdentityEditor
          key={currentEnterprise?.UUID}
          kind="site"
          onCancel={() => setCreating(false)}
          onSaved={() => {
            setCreating(false)
            setPage(1)
            resource.reload()
          }}
        />
      )}
    </main>
  )
}
